import { z } from 'zod';

/** Same bounds as the contract (PasswordResetComplete.newPassword: 12–256); the server checks the full policy. */
export const PASSWORD_MIN = 12;

export const newPasswordSchema = z
  .object({
    newPassword: z.string().min(PASSWORD_MIN, 'validation.newPassword').max(256, 'validation.newPasswordMax'),
    confirmPassword: z.string().min(1, 'validation.confirmPassword'),
  })
  .refine((v) => v.newPassword === v.confirmPassword, { path: ['confirmPassword'], message: 'validation.passwordMismatch' });
export type NewPasswordValues = z.infer<typeof newPasswordSchema>;

export const resetRequestSchema = z.object({
  email: z.string().trim().min(1, 'validation.email').pipe(z.email('validation.email')),
});
export type ResetRequestValues = z.infer<typeof resetRequestSchema>;

/** Payload of POST /auth/password-reset/complete. */
export const toCompleteRequest = (token: string, v: NewPasswordValues) => ({ token, newPassword: v.newPassword });
